import { LimitPeriod, selfExclusionPeriodKeys, TimeoutPeriod } from './stayingInControlEnums';
import { Content, LimitTimeFrame, TimeFrame } from './stayingInControlInterfaces';

export const lossLimit: Content = {
  titleId: 'profile.staying_in_control.set_loss_limit',
  explanationId: 'profile.staying_in_control.set_loss_limit_explanation',
};

export const depositLimit: Content = {
  titleId: 'profile.staying_in_control.set_deposit_limit',
  explanationId: 'profile.staying_in_control.set_deposit_limit_explanation',
};

export const realityCheck: Content = {
  titleId: 'profile.staying_in_control.set_reality_check',
  explanationId: 'profile.staying_in_control.set_reality_check_explanation',
};

export const productBlock: Content = {
  titleId: 'common.manage_product_block',
  explanationId: 'profile.staying_in_control.manage_product_block_explanation',
};

export const timeOut: Content = {
  titleId: 'profile.staying_in_control.activate_timeout',
  explanationId: 'profile.staying_in_control.activate_timeout_explanation',
  guideline: 'profile.staying_in_control.activate_timeout_guideline',
};

export const selfExclusion: Content = {
  titleId: 'common.activate_self_exclusion',
  explanationId: 'profile.staying_in_control.activate_self_exclusion_explanation',
};

export const limitTimeFrames: LimitTimeFrame[] = [
  {
    titleId: 'common.24_hours',
    key: LimitPeriod.DAY,
  },
  {
    titleId: 'common.7_days',
    key: LimitPeriod.WEEK,
  },
  {
    titleId: 'common.30_days',
    key: LimitPeriod.MONTH,
  },
];

export const timeoutTimeFrames: LimitTimeFrame[] = [
  {
    titleId: 'common.24_hours',
    key: TimeoutPeriod.DAY,
  },
  {
    titleId: 'common.7_days',
    key: TimeoutPeriod.WEEK,
  },
  {
    titleId: 'common.30_days',
    key: TimeoutPeriod.MONTH,
  },
  {
    titleId: 'profile.staying_in_control.custom_date',
    key: TimeoutPeriod.CUSTOM,
  },
];

export const realityTimeFrames: TimeFrame[] = [
  {
    titleId: 'profile.staying_in_control.10_minutes',
    key: '10',
  },
  {
    titleId: 'profile.staying_in_control.30_minutes',
    key: '30',
  },
  {
    titleId: 'profile.staying_in_control.1_hour',
    key: '60',
  },
];

export const selfExclusionTimeFrames: TimeFrame[] = [
  {
    titleId: 'profile.staying_in_control.6_months',
    key: selfExclusionPeriodKeys.MONTHS_6,
  },
  {
    titleId: 'profile.staying_in_control.1_year',
    key: selfExclusionPeriodKeys.YEAR_1,
  },
  {
    titleId: 'profile.staying_in_control.2_years',
    key: selfExclusionPeriodKeys.YEAR_2,
  },
  {
    titleId: 'profile.staying_in_control.3_years',
    key: selfExclusionPeriodKeys.YEAR_3,
  },
  {
    titleId: 'profile.staying_in_control.4_years',
    key: selfExclusionPeriodKeys.YEAR_4,
  },
  {
    titleId: 'profile.staying_in_control.5_years',
    key: selfExclusionPeriodKeys.YEAR_5,
  },
];

export const PRODUCT_BLOCK_REASON_ID = 11;
export const PRODUCT_BLOCK_LIFETIME_ID = '100-y';

export const SELF_EXCLUDE_REASON_ID = 1;
export const SELF_EXCLUDE_PRODUCT_ID = -1;
